import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../../../Services/api.service';
import { LoaderService } from '../../../../../Services/loader.service';
import { StorageService } from "../../../../../Services/storage.service"
import { CommonServices } from '../../../../../Services/common.service';
import { ExcelExportService } from '../../../../../Services/excel.service';
import { S3BudgetService } from "../../../../../Services/s3Budget.service";
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { resolve } from 'dns';
import { rejects } from 'assert';
@Component({
  selector: 'harsh-acceleration-report',
  templateUrl: './harsh-acceleration-report.component.html',
  styleUrls: ['./harsh-acceleration-report.component.css']
})
export class HarshAccelerationReportComponent implements OnInit {
  public formFilters: any = FormGroup;
  @ViewChild('search') searchTextBox: ElementRef;

  selectFormControl = new FormControl();

  public excelData = {};
  public allVehDownload: boolean;
  public tableData = [];
  public cols = [
    { key: '#', display: '#' },
    { key: 'DateTime', display: 'Date / Time', headerConfig: { isDefault: true } },
    {
      key: 'vehRegNo', display: 'Reg. No', headerConfig: { isDefault: true },
      subKey: 'compRating',
      config: {
        isComplaint: true,  // give complaint first
        isVehicle: true
      }
    },
    { key: 'driverName', display: 'Driver Name', headerConfig: { isDefault: true } },
    { key: 'driverMobile', display: 'Driver Mobile', headerConfig: { isDefault: true } },
    { key: 'accBrak', display: 'Event', headerConfig: { isDefault: true } },
    { key: 'speedDifference', display: 'Speed Difference (km/h)', style: 'align:center', headerConfig: { isDefault: true } },
    { key: 'fromToSpd', display: 'Speed Range (km/h)', style: 'align:center', headerConfig: { isDefault: true } },

  ];
  public noDataFoundEnable: boolean = false;
  public localStorage;
  public processedData: any = {};
  public objectKeys = Object.keys;
  public totalDistance: any = 0;
  public myDate = new Date();
  public maxDate: any;
  searchTextboxControl: any;
  public enableAllOption: boolean = true;
  // selectFormControl: any;

  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  addObj: any = {};

  data: any;
  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService,
    public storage: StorageService,
    public s2Service: S3BudgetService
  ) {
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    this.localStorage = this.storage.get('vendorID_orgID');

    this.getRegNos();
    this.getVehicleDetails();
  }

  public vehicleRegNos: any
  public showTable: boolean;
  public vehicles;

  getVehicleDetails() {

    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;
        // console.log('vehicle ',this.vehicles);
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  filteredOptions: Observable<any[]>;
  selectedValues = [];

  ngOnInit(): void {
  
  }

  getRegNos() {

    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  async getVehicleEncryptRegNo(regNo) {
    return new Promise((resolve, rejects) => {
      this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
        if (res['status'] == 'success') resolve(res['data']);
        else rejects(res['data'])
      })
    })
  }

  async submitForm(obj: any) {
    try {
      if (obj) {
        const { formFilds } = obj;

        // Reset table state
        // this.showTable = false;
        this.excelData = [];
        // this.tableData = [];
        // this.noDataFoundEnable = false;
        this.loader.show();

        // Handle vehicle selection
        const selectedVehs = formFilds.selectedVehicle === 'ALL'
          ? this.vehicles.filter(veh => veh.vehRegNo).map(veh => veh.vehRegNo).sort()
          : [formFilds.selectedVehicle];

        if (selectedVehs?.length > 0) {
          formFilds['vehRegNo'] = selectedVehs;
        }

        // Handle date conversion
        const startDate = new Date(formFilds.sDate);
        const endDate = new Date(formFilds.eDate);
        endDate.setHours(23, 59, 59);  // Set the end date to 23:59:59 for the full day

        // Build payload
        const payload = {
          startDate: startDate.getTime(),
          endDate: endDate.getTime(),
          limit: 10,
          page: 1,
          type: "table",
        };
        if (formFilds['vehRegNo']?.length > 0 && !formFilds['vehRegNo'].includes("")) {
          payload['vehRegNo'] = formFilds['vehRegNo']
        }
        this.addObj = payload;
        this.getHarshAccelerationData(payload);
      }
    } catch (error) {
      console.error("Form submission error:", error);
    }
  }


  getHarshAccelerationData(payload) {
    this.api.transportManagerHarshAccelerationReport(payload).then((response: any) => {
      if (response.status == 'success' && response.tableData.length > 0) {
        const accBrakMap = {
          braking: 'Braking',
          acc: 'Acceleration'
        };

        this.processPagination(response, payload);
        this.tableData = response['tableData'].map((data) => {

          const difference = Number(data['toSpd']) - Number(data['fromSpd']);
          const iconOption = difference < 0 ? 'minus' : 'plus';
          const speedDifference = `${Math.abs(difference)} ${difference < 0 ? ' ( - )' : ' ( + )'}`;

          data['fromSpd'] = data['fromSpd'].length == 1 ? "0" + data['fromSpd'] : data['fromSpd'];
          data['toSpd'] = data['toSpd'].length == 1 ? "0" + data['toSpd'] : data['toSpd'];

          return {
            vehRegNo: data['vehRegNo'],
            DateTime: this.comService.timestampToDate(data?.date, 'DMY H:M:S'),
            driverName: data['driverInfo']['name'] ? data['driverInfo']['name'] : '--',
            driverMobile: data['driverInfo']['number'] ? data['driverInfo']['number'] : '--',
            accBrak: accBrakMap[data['accBrak']] || '',
            Speed: data['spd'],
            fromToSpd: data['fromSpd'] + ' ' + ' - ' + ' ' + data['toSpd'],
            speedDifference: speedDifference,
            iconOption: iconOption
          };
        });

        this.loader.hide();
        this.showTable = true;
      } else {
        this.loader.hide();
        this.showTable = false;
        this.noDataFoundEnable = true;
        this.tableData = [];
      }

    }).catch((err) => {
      this.loader.hide();
      console.log('errr', err)
    });

  }

  pagination(data) {
    this.addObj['page'] = data['page'],
      this.addObj['limit'] = data['limit'];
    this.getHarshAccelerationData(this.addObj)
  }

  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  downloadXL() {
    let payload = { ... this.addObj };
    delete payload['page'];
    delete payload['limit'];
    payload['type'] = 'excel';
    this.api.transportManagerHarshAccelerationReport(payload).then((response: any) => {
      if (response.status == 'success' && response.excelData.length > 0) {
        this.generateExcel(response.excelData, payload)
      }

    }).catch((err) => {
      this.loader.hide();
      console.log('errr', err)
    });
  }

  generateExcel(exlData, dateData) {

    this.excelData = {};
    let data = [];
    let serialNo = 1;
    for (let i = 0; i < exlData.length; i++) {
      let item = exlData[i];
      const accBrakMap = {
        braking: 'Braking',
        acc: 'Acceleration'
      };
      try {
        let speedDifference = function (speed) {
          const difference = Number(speed['toSpd']) - Number(speed['fromSpd']);
          return `${Math.abs(difference)} ${difference < 0 ? ' ( - )' : ' ( + )'}`;
        }
        let res = {
          value: [
            serialNo++,
            item.date ? this.comService.timestampToDate(item?.date, 'DMY H:M:S') : '---',
            item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '--',
            item.driverInfo && item.driverInfo['name'] ? item.driverInfo['name'] == '--' ? item.driverInfo['name'] : this.comService.convertTitleCase(item?.driverInfo['name']) : '--',
            item.driverInfo && item.driverInfo['number'] ? item?.driverInfo['number'] : '--',
            accBrakMap[item['accBrak']] || '',
            speedDifference(item),
            item['fromSpd'] + ' ' + ' - ' + ' ' + item['toSpd']
          ],

          border: {
            right: { style: 'thin' }, bottom: { style: 'thin' },
          },
        };
        data.push(res);

      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = 'H';
      let customizedData = [];
      let titleRow = {
        value: ['Harsh Acceleration Braking'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);
      rowCount = rowCount + 2;
      let subtitleRow = {
        value: [
          "Start Date       : " + this.comService.timestampToDate(dateData.startDate, 'DMY') + "\n" +
          "End Date         : " + this.comService.timestampToDate(dateData.endDate, 'DMY') + ""],
        font: { name: 'Corbel', family: 4, size: 12, },
        border: { right: { style: 'thin' } },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Date / Time', 'Reg. No', "Driver Name", 'Driver Mobile', 'Event', 'Speed Difference (km/h)', 'Speed Range (km/h)'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = 'Harsh Acceleration Braking'

      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 18 }, { colNo: 4, width: 18 }, { colNo: 5, width: 20 }, { colNo: 6, width: 25 }, { colNo: 7, width: 20 }, { colNo: 8, width: 20 },],
        }
      }
      this.downloadExlReport('Harsh Acceleration Braking Report');
    }
  }

  downloadExlReport(data: string) {
    this.excel.generateExcel(this.excelData, data + '-' + this.comService.timestampToDate(new Date().getTime(), 'DMY') + ' ' + '.xlsx');
  }
}
